/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';

import { translate } from '../../../common/translation/translate';
import { ErrorBoundaryIcon } from '../../common/errorBoundary/errorBoundaryIcon';

export const OutdoorSportsStoriesLoadingErrorUI = memo(() => {
    return (
        <Container>
            <IconWrapper>
                <ErrorBoundaryIcon />
            </IconWrapper>
            <NoDataText isTitle={true}>{translate('failedToLoad')}</NoDataText>
            <NoDataText isTitle={false}>
                <div>{translate('dataLoadFirstErrorMessage')}</div>
                <div>{translate('dataLoadSecondErrorMessage')}</div>
            </NoDataText>
        </Container>
    );
});

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10%;
    padding: 12px 10px;
`;

export const IconWrapper = styled.span`
    display: flex;
    flex-direction: column;
    background: #F9F9F9;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

interface NoDataTextProps {
    isTitle: boolean;
}
export const NoDataText = styled.div<NoDataTextProps>`
    display: flex;
    flex-direction: column;
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    width: 100%;
    margin-top: 20px;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-weight: ${({ isTitle }) => isTitle ? '600' : 'normal' };
`;
